import { dataFilterSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFilterSolid = /*#__PURE__*/createIcon(dataFilterSolid)
export default IconFilterSolid
